import React from 'react';
import Navigation from './Navigation';
import HeroSection from './HeroSection';
import ContactForm from './ContactForm';
import ContactInfo from './ContactInfo';
import Footer from './Footer';
import { siteConfig } from '../config/siteConfig';
import './ContactUs.css';

const ContactUs = ({ config = siteConfig }) => {
  return (
    <div className="contact-us">
      <Navigation config={config.navigation} alwaysScrolled={true} />
      <HeroSection config={config.contactHero} className="contact-hero" />
      <div className="contact-content">
        <div className="contact-form-and-info">
          <div className="contact-form-section">
            <ContactForm config={config.contactForm} />
          </div>
          <div className="contact-info-section">
            <ContactInfo config={config.contactInfo} />
          </div>
        </div>
      </div>
      <Footer config={config.footer} />
    </div>
  );
};

export default ContactUs;
